<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
</mat-dialog-actions>
<mat-dialog-content>
  <h1 mat-dialog-title>{{ "history.title" | translate }}</h1>
  <div class="loading" *ngIf="loading === true">
    <mat-spinner diameter="20"></mat-spinner>
    {{ "history.loading" | translate }}
  </div>
  <div
    class="history"
    *ngIf="loading === false && history.length > 0; else empty"
  >
    <ca-entity-history-item
      *ngFor="let event of history | sortBy : 'created' : 'descending'"
      [event]="event"
      [trailing]="
        event.type === CREATED || event.type === UPDATED
          ? event.meta?.body
          : null
      "
      [member]="members[event.memberId]"
    >
    </ca-entity-history-item>
  </div>
  <ng-template #empty>
    <p *ngIf="loading === false && history.length === 0">
      {{ "history.empty" | translate }}
    </p>
  </ng-template>
</mat-dialog-content>
